import { render, staticRenderFns } from "./DetailText.vue?vue&type=template&id=08b6905b&"
import script from "./DetailText.vue?vue&type=script&lang=js&"
export * from "./DetailText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports